import { render, staticRenderFns } from "./clipboard_button.vue.js?vue&type=template&id=8e838370!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./clipboard_button.vue?vue&type=template&id=8e838370"
import script from "./clipboard_button.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./clipboard_button.vue?vue&type=script&lang=js"
export * from "./clipboard_button.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./clipboard_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports